import Button from "components/Button/Button";
import styles from './Notes.module.scss';
import React from "react";
import Toastr from "components/Toastr";
import { store } from "stores/Store";
import { date2usSlashDateTime } from "helpers";
import useExternalApiService from "helpers/ExternalApiService";
import { observer } from "mobx-react";



const Notes = observer(() => {
  const [notes, setNotes] = React.useState('');
  const [lastSaved, setLastSaved] = React.useState('');
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState('');
  const [isDirty, setIsDirty] = React.useState(false);
  const apiUrl = process.env.REACT_APP_EAI_URL;
  const { postData, putData } = useExternalApiService(apiUrl);


  React.useEffect(() => {
    if(store.currentPractitioner && store.currentPractitioner.general_notes) {
      setNotes(store.currentPractitioner?.notes + '\n \n'  + store.currentPractitioner.general_notes);
      setIsDirty(true);
      setShowToast(true);
      setToastMessage('You have unsaved changes');
    } else {
      setNotes(store.currentPractitioner?.notes);
    }
    if(store.currentPractitioner?.updated_at) {
      setLastSaved(date2usSlashDateTime(store.currentPractitioner?.updated_at).split(' @')[0].replace(/\//g, '.'));
    }
  }, [store.currentPractitioner]);

  const handleShowToast = (message: string) => {
    setShowToast(true);
    setToastMessage(message);
  };

  const updatePractitionerNotes = async (notes: string) => {
    const result = await putData(`/api/add_practitioner_to_chat/${store.currentPractitioner?.id}`, {
      "practitioner_data": {
        "notes": notes,
      }
    });

    //clear general notes for practitioner
    store.setCurrentPractitioner({...store.currentPractitioner, general_notes: '', notes: notes});
    setLastSaved(date2usSlashDateTime(new Date().toISOString()).split(' @')[0].replace(/\//g, '.'));
    store.setCurrentPractitioner({...store.currentPractitioner, updated_at: new Date().toISOString()});
  }

  const handleSave = async () => {
    // post request to update notes
    updatePractitionerNotes(notes);
    setIsDirty(false);
    handleShowToast('Notes Saved');
  }

  const handleUndo = () => {
    setIsDirty(false);
    setNotes(store.currentPractitioner?.notes);
    setLastSaved(date2usSlashDateTime(store.currentPractitioner?.updated_at).split(' @')[0].replace(/\//g, '.'));
    handleShowToast('Notes Restored');
  }

  const onChangeNotes = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNotes(e.target.value);
    setIsDirty(true);
    setShowToast(true);
    setToastMessage('You have unsaved changes');
  }

  return (
    <div className={styles.notesWrapper}>
      <div className={styles.headerWrapper + ' ' + (!store.currentPractitioner?.notes ? styles.headerWrapperWithoutNotes : '')}>
        {store.currentPractitioner?.notes && (
          <div>LAST SAVED: {lastSaved.replace(/\//g, '.')}</div>
        )}
        {isDirty && (
          <div className={styles.buttonsWrapper}>
            <Button type="outline" onClick={handleUndo}>UNDO</Button>
            <Button textColor="white" color="#00DC4980" borderColor="#00DC49CC" type="outline" onClick={handleSave}>SAVE</Button>
          </div>
        )}
      </div>
      <textarea
        value={notes}
        onChange={onChangeNotes}
        className={styles.textarea}
        placeholder="Enter your notes here..."
      />
      <Toastr backgroundColor={isDirty ? '#DDE63780' : 'white'} message={toastMessage} isVisible={showToast || isDirty} onClose={() => setShowToast(false)} />
    </div>
  )
});

export default Notes;
